import { render } from "./PracticeList.vue?vue&type=template&id=d8692bfe&ts=true"
import script from "./PracticeList.vue?vue&type=script&lang=ts"
export * from "./PracticeList.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__